module.exports = __webpack_public_path__ + "img/solutionBanner_4.93868596.png";